import React from 'react';
import { ApolloError } from '@apollo/client';
import { useMount } from 'react-use';

import {
  AutoModalPriority,
  useAutoModal,
} from '../../../../common/AutoModalProvider';
import useRemoveStateFromLocation from '../../../../common/hooks/useRemoveStateFromLocation';
import { EmployerPurchaseProductType } from '../../../../common/interfaces/entities';
import { PurchaseSupportedPremiumPlanType } from '../../../../common/interfaces/premium-plan';
import useGetErrorFromPremiumPlanPurchaseFailedState from './hooks/useGetErrorFromVIPPurchaseFailedState';
import { usePremiumPlanPurchaseModal } from './Providers/PremiumPlanPurchaseModalContext';

type GlintsVIPPurchaseModalContentProps = {
  apolloError: ApolloError;
  premiumPlanTypeToPurchase: PurchaseSupportedPremiumPlanType;
};

const PremiumPurchaseModalContent = ({
  apolloError,
  premiumPlanTypeToPurchase,
}: GlintsVIPPurchaseModalContentProps) => {
  const { removeStateFromLocation } = useRemoveStateFromLocation();
  const { openPremiumPlanPurchaseModal } = usePremiumPlanPurchaseModal();

  useMount(() => {
    openPremiumPlanPurchaseModal({
      errorBannerProviderInitialValue: apolloError,
      premiumPlanTypeToPurchase: premiumPlanTypeToPurchase,
      trackingSource:
        'subscription_plan_purchase_modal_for_after_payment_error',
      onClose: () => {
        removeStateFromLocation('premiumPlanPurchaseFailed');
      },
    });
  });

  return null;
};

export default function PremiumPlanPurchaseModalForAfterPayment() {
  const errorData = useGetErrorFromPremiumPlanPurchaseFailedState();
  const canShow = useAutoModal(
    AutoModalPriority.Transaction,
    errorData?.product.type === EmployerPurchaseProductType.PREMIUM_PLAN
  );
  if (!errorData || !canShow) return null;
  const { error, product } = errorData;

  if (product.type !== EmployerPurchaseProductType.PREMIUM_PLAN) {
    return null;
  }

  return (
    <PremiumPurchaseModalContent
      apolloError={error}
      premiumPlanTypeToPurchase={
        product.variantDetail.planType as PurchaseSupportedPremiumPlanType
      }
    />
  );
}
